import React from 'react';
import PrivacyPolicy from './PrivacyPolicy';

const TracsessOrganizePrivacyPolicy: React.FC = () => {
  return (
    <PrivacyPolicy
      appName="Tracsess Organize"
      pdfUrl="https://tracess.s3.ap-south-1.amazonaws.com/documents/organize/PP_Tracsess_Organize.pdf"
      title="Tracsess Organize Privacy Policy"
    />
  );
};

export default TracsessOrganizePrivacyPolicy; 